export const defaultCellBorderStyles = [
  { key: 'Thin', src: 'icon-linestyle-solid-line-wide' },
  { key: 'Dotted', src: 'icon-linestyle-dotted-line-wide' },
  { key: 'Dashed', src: 'icon-linestyle-dashed-line-wide' }
];